import React from 'react';
import {StyledCard, PanelBody, PanelHeader, PanelTitle} from "./styleHelper";

export const Card = ({title, children}) => {
    return (
        <StyledCard>
            <PanelHeader>
                <PanelTitle>{title}</PanelTitle>
            </PanelHeader>
            <PanelBody>
                {children}
            </PanelBody>
        </StyledCard>
    )
};



// WEBPACK FOOTER //
// ./src/styledComponents.jsx